// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2524":"a26d89d6","2654":"b9619d2a","3625":"ca23e6ff","5787":"523c3cfa","8172":"12a6aa5e","8464":"6e47dd0e","9886":"7a32297d"}[chunkId] + ".chunk.css";
};